// extracted by mini-css-extract-plugin
export default {"baseStyles":"_3WyVF"};